import React from 'react'

const ArrowLeft = ({ dark }) => <i className={"fas fa-arrow-left fa-2x " + (dark && 'cs-dark')}></i>
const PlusIcon = () => <i className="fas fa-plus"></i>

export {
  ArrowLeft, PlusIcon
}